import {
  omit, cloneDeep, set, result
} from 'lodash';

export default (visit) => {
  const clonedVisit = cloneDeep(visit);

  set(clonedVisit, 'visit_scores', []);
  set(clonedVisit, 'isTooltipVisible', false);

  clonedVisit.visit_scores.push({
    type: 'all',
    scores: result(clonedVisit, 'scores', {}),
    highlights: result(clonedVisit, 'highlights', {})
  });

  const filteredScores = result(clonedVisit, 'filtered_scores', []);

  filteredScores.forEach((item) => {
    clonedVisit.visit_scores.push({
      type: item.key,
      scores: result(item, 'scores', {}),
      highlights: result(item, 'highlights', {})
    });
  });

  return omit(clonedVisit, ['scores', 'highlights', 'filtered_scores']);
};
